import React from 'react';
import AdminReporting from '@/components/admin/AdminReporting';

export default function AdminReportingPage() {
  return <AdminReporting />;
}